<template>
  <div class="row">
    <div class="col-lg text-center">
      <h4 class="card-title style-title">Vehicle Update</h4>
      <h5
        class="description style-title"
      >Please fill in all the required details to update existing Vehicle.</h5>
    </div>

    <div class="col-md-12">
      <card class="stacked-form">
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-7 ml-auto mr-auto">
              <div class="row">
                <div class="col-12">
                  <h3 style="border-bottom: solid red">Vehicle Details</h3>
                </div>
                <div class="col-md-6">
                  <base-input label="Vehicle Registration Number" v-model="regno" disabled></base-input>
                  <base-input
                    label="Vehicle Category"
                    placeholder="Category"
                    name="required"
                    type="text"
                    required
                  >
                    <el-select
                      class="select-info"
                      size="large"
                      placeholder="Choose..."
                      v-model="selects.selectCategory"
                    >
                      <el-option
                        v-for="dept in selects.category"
                        :value="dept.value"
                        :label="dept.label"
                        :key="dept.value"
                      ></el-option>
                    </el-select>
                  </base-input>
                  <base-input label="Vehicle Weight (BDM)" v-model="bdm" required></base-input>
                  <base-input label="Vehicle Weight (BTM)" v-model="btm" required></base-input>
                  <base-input label="Manufacture" v-model="manufacture" required></base-input>
                  <base-input label="Road Tax / Insurance" required>
                    <el-date-picker type="date" placeholder="Date Picker" v-model="dateRoadtax"></el-date-picker>
                  </base-input>
                  <base-input label="Schedule Preventive Maintenace Date" required>
                    <el-date-picker type="date" placeholder="Date Picker" v-model="dateMaintenance"></el-date-picker>
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="Model" v-model="model" required></base-input>
                  <base-input label="Size" v-model="size" required></base-input>
                  <base-input label="Chassis No" v-model="chassno" required></base-input>
                  <base-input label="Engine No" v-model="engine" required></base-input>
                  <base-input label="Transmission Type" v-model="transport" required></base-input>
                  <base-input label="Odometer" v-model="odometer" required></base-input>
                  <base-input label="PUSPAKOM Inspection Date" required>
                    <el-date-picker type="date" placeholder="Date Picker" v-model="datePUSPAKOM"></el-date-picker>
                  </base-input>
                </div>
              </div>
            </div>
            <div class="col-md-4 ml-auto mr-auto">
              <h3 style="border-bottom: solid red">Company Details</h3>
              <div class="col-md-12">
                <!-- <base-input
                  label="Department"
                  placeholder="Department"
                  name="required"
                  type="text"
                  required
                >
                  <el-select
                    class="select-info"
                    size="large"
                    placeholder="Choose..."
                    v-model="selects.selectDept"
                  >
                    <el-option
                      v-for="dept in selects.department"
                      :value="dept.value"
                      :label="dept.label"
                      :key="dept.value"
                    ></el-option>
                  </el-select>
                </base-input>-->
                <base-input label="Site" placeholder="Site" name="required" type="text" required>
                  <el-select
                    class="select-info"
                    size="large"
                    placeholder="Choose..."
                    v-model="selects.selectSite"
                  >
                    <el-option
                      v-for="site in selects.site"
                      :value="site.value"
                      :label="site.label"
                      :key="site.value"
                    ></el-option>
                  </el-select>
                </base-input>
                <base-input
                  label="Status"
                  placeholder="Status"
                  name="required"
                  type="text"
                  required
                >
                  <el-select
                    class="select-info"
                    size="large"
                    placeholder="Choose..."
                    v-model="selects.selectStatus"
                  >
                    <el-option
                      v-for="status in selects.status"
                      :value="status.value"
                      :label="status.label"
                      :key="status.value"
                    ></el-option>
                  </el-select>
                </base-input>
                <div v-if="selects.selectStatus == 2">
                  <h3 class="new-details">Additional Info</h3>
                  <base-input label="Breakdown Date" required>
                    <el-date-picker type="date" placeholder="Date Picker" v-model="dateBreakdown"></el-date-picker>
                  </base-input>
                  <base-input label="ETD Date" required>
                    <el-date-picker type="date" placeholder="Date Picker" v-model="dateETD"></el-date-picker>
                  </base-input>
                </div>
                <div v-if="selects.selectStatus == 3">
                  <h3 class="new-details">Additional Info</h3>
                  <base-input
                    label="Replacement Vehicle"
                    placeholder="Replacement Vehicle"
                    name="required"
                    type="text"
                    required
                  >
                    <el-select
                      class="select-info"
                      size="large"
                      placeholder="Choose..."
                      v-model="selects.replacementVehicle"
                    >
                      <el-option
                        v-for="vehicle in selects.vehicle"
                        :value="vehicle.value"
                        :label="vehicle.label"
                        :key="vehicle.value"
                      ></el-option>
                    </el-select>
                  </base-input>
                  <base-input label="Replacement Date" required>
                    <el-date-picker type="date" placeholder="Date Picker" v-model="dateReplacement"></el-date-picker>
                  </base-input>
                </div>
              </div>
            </div>

            <div class="col-lg-12 text-center">
              <base-button
                @click="updateVehicle()"
                class="mt-3"
                native-type="submit"
                type="primary"
              >Submit</base-button>
            </div>
          </div>
        </form>
      </card>
    </div>
  </div>
</template>
<script>
import { BaseCheckbox, BaseRadio } from "src/components/index";
import { TimeSelect, DatePicker, Select, Option } from "element-ui";
import moment from "moment";
import swal from "sweetalert2";

export default {
  components: {
    BaseCheckbox,
    [Select.name]: Select,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Option.name]: Option,
    BaseRadio
  },
  data() {
    return {
      dateRoadtax: "",
      dateMaintenance: "",
      datePUSPAKOM: "",
      dateBreakdown: "",
      dateETD: "",
      dateReplacement: "",
      selects: {
        selectDept: "",
        selectSite: "",
        selectStatus: "",
        selectCategory: "",
        replacementVehicle: "",
        department: [],
        site: [],
        status: [],
        category: [],
        vehicle: []
      },
      regno: "",
      bdm: "",
      manufacture: "",
      btm: "",
      model: "",
      size: "",
      chassno: "",
      engine: "",
      transport: "",
      odometer: "",
      empID: "",
      siteData: null
    };
  },

  methods: {
    getVehicleDetails(vehregno) {
      console.log(vehregno)
      this.$http.get(`:9993/api/v1/register/vehicle/${vehregno}`).then(res => {
        if (!res.error) {
          let data = res.message;
          console.log(data);
          this.selects.selectCategory = data.CategoryID;
          this.bdm = data.Bdm;
          this.btm = data.Btm;
          this.manufacture = data.Manufacture;
          this.model = data.Model;
          this.size = data.Size;
          this.chassno = data.ChassisNo;
          this.engine = data.EngineNo;
          this.transport = data.TransportType;

          let puspakom = moment(data.PuspakomDate).format("YYYY-MM-DD");
          console.log(puspakom)
          if(puspakom == "Invalid date"){
            puspakom = ""
          }
          this.datePUSPAKOM = puspakom
          console.log(this.datePUSPAKOM)

          let roadtax = moment(data.RoadTaxDate).format("YYYY-MM-DD");
          console.log(roadtax)
          if(roadtax == "Invalid date"){
            roadtax = ""
          }
          this.dateRoadtax = roadtax
          console.log(this.dateRoadtax)

          this.selects.selectSite = data.SiteID;
          this.selects.selectDept = data.DeptID;
          this.odometer = data.Odometer;

          let maintenance = moment(data.MaintenanceDate).format("YYYY-MM-DD");
          if(maintenance == "Invalid date"){
            maintenance = ""
          }
          this.dateMaintenance = maintenance;

          this.selects.selectStatus = data.StatusID;

          if (this.selects.selectStatus == 2) {
            let etd = moment(data.EtdDate).format("YYYY-MM-DD")
            if(etd == "Invalid date"){
              etd = ""
            }
            this.dateETD = etd;

            let breakdown = moment(data.BreakdownDate).format("YYYY-MM-DD");
            if(breakdown == "Invalid date"){
              breakdown == ""
            }
            this.dateBreakdown = breakdown

          } else if (this.selects.selectStatus == 3) {
            this.selects.replacementVehicle = data.ReplaceVehicle;

            let replacement = moment(data.ReplacementDate).format("YYYY-MM-DD");
            if(replacement == "Invalid date"){
              replacement = ""
            }
            this.dateReplacement = replacement
          }
        }
      });
    },
    getStatus() {
      this.$http.get(":9993/api/v1/setting/status").then(res => {
        if (!res.error) {
          console.log(res.message);
          let data = res.message;

          for (let i = 0; i < data.length; i++) {
            if (data[i].StatusName != "REPLACEMENT") {
              let statuses = {
                value: data[i].StatusID,
                label: data[i].StatusName
              };
              this.selects.status.push(statuses);
            }
          }

          this.selects.selectStatus = this.selects.status[0].value;
        }
      });
    },
    getCategory() {
      this.$http.get(":9993/api/v1/setting/category").then(res => {
        if (!res.error) {
          let data = res.message;
          console.log(data)
          for (let i = 0; i < data.length; i++) {
            let categories = {
              value: data[i].CategoryID,
              label: data[i].CategoryName
            };

            this.selects.category.push(categories);
          }
        }
      });
    },
    getSite() {
      this.$http.get(":9993/api/v1/register/site").then(res => {
        if (!res.error) {
          let data = res.message;
          this.siteData = data;
          console.log(data)
          for (let i = 0; i < data.length; i++) {
            let sites = {
              value: data[i].SiteID,
              label: data[i].SiteName
            };

            this.selects.site.push(sites);
          }
        }
      });
    },
    // getDepartment() {
    //   this.$http.get(":9993/api/v1/setting/department").then(res => {
    //     if (!res.error) {
    //       let data = res.message;
    //       console.log(data)
    //       for (let i = 0; i < data.length; i++) {
    //         let departments = {
    //           value: data[i].DeptID,
    //           label: data[i].DeptName
    //         };

    //         this.selects.department.push(departments);
    //       }
    //     }
    //   });
    // },
    callUpdateVehicle(body) {
      this.$http.put(":9993/api/v1/register/vehicle/"+ body.VehicleNo, body).then(res => {
        if (!res.error) {
          swal({
            title: res.message,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            cancelButtonClass: "btn btn-danger btn-fill",
            confirmButtonText: "Okay!",
            buttonsStyling: false
          });
          
        }
      });
    },
    updateVehicle() {
      const STATUS = this.selects.selectStatus;

      if (
        this.regno == "" ||
        this.selects.selectCategory == "" ||
        // this.bdm == "" ||
        // this.btm == "" ||
        // this.manufacture == "" ||
        // this.model == "" ||
        // this.size == "" ||
        // this.chassno == "" ||
        // this.engine == "" ||
        // this.transport == "" ||
        this.datePUSPAKOM == "" ||
        this.dateRoadtax == "" ||
        this.selects.selectSite == "" ||
        // this.selects.selectDept == "" ||
        this.odometer == "" ||
        this.dateMaintenance == ""
      ) {
        swal({
          title: "Please fill in all the form!",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Okay!",
          buttonsStyling: false
        });
      } else {
        let deptID;

        for (let i = 0; i < this.siteData.length; i++) {
          if (this.selects.selectSite == this.siteData[i].SiteID) {
            this.empID = this.siteData[i].EmpID;
            deptID = this.siteData[i].DeptID;
          }
        }
        let body = {
          VehicleNo: this.regno,
          CategoryID: this.selects.selectCategory,
          BDM: this.bdm,
          BTM: this.btm,
          Manufacture: this.manufacture,
          Model: this.model,
          Size: this.size,
          ChassisNo: this.chassno,
          EngineNo: this.engine,
          TransportType: this.transport,
          PuspakomDate: moment(this.datePUSPAKOM).format("YYYY-MM-DD"),
          RoadTaxDate: moment(this.dateRoadtax).format("YYYY-MM-DD"),
          SiteID: this.selects.selectSite,
          DeptID: deptID,
          EmpID: this.empID,
          Odometer: this.odometer,
          StatusID: this.selects.selectStatus,
          MaintenanceDate: moment(this.dateMaintenance).format("YYYY-MM-DD")
        };
        console.log(body);
        if (STATUS == 1) {
          this.callUpdateVehicle(body);
          // CALL API
        } else if (STATUS == 2) {
          if (this.dateETD == "" || this.dateBreakdown == "") {
            swal({
              title: "Please fill in the additional details!",
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              cancelButtonClass: "btn btn-danger btn-fill",
              confirmButtonText: "Okay!",
              buttonsStyling: false
            });
          } else {
            body["breakdowndate"] = moment(this.dateBreakdown).format(
              "YYYY-MM-DD"
            );
            body["etd"] = moment(this.dateETD).format("YYYY-MM-DD");
            this.callUpdateVehicle(body);
          }
        }
      }
    }
  },

  created() {
    this.regno = this.$route.params.vehregno;
    this.getVehicleDetails(this.regno);
    this.getStatus();
    this.getCategory();
    this.getSite();
    // this.getDepartment();
    // this.listBreakdown();
  }
};
</script>
<style lang="scss">
.new-details {
  padding-top: 2%;
  border-bottom: solid red;
}
</style>
